import { createContext } from 'react';
import { IMarketInsightsContext } from './types';

export default createContext<IMarketInsightsContext>({
  marketInsights: null,
  loading: false,
});
